module.exports = {
  "id": "2a69b125-2948-4f68-a0d3-2dde31d7965d",
  "gtmIds": [
    "GTM-TCVP4FCV",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "startTracking": "after_accepting_cookies",
  "hasInAppVersion": false,
  "group": "moreys",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "en-US"
  ],
  "website": "https://jobs.moreyspiers.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}